__turbopack_context__.v({
  "button": "testimonialCarousel-module-scss-module__HcCK_W__button",
  "container": "testimonialCarousel-module-scss-module__HcCK_W__container",
  "header": "testimonialCarousel-module-scss-module__HcCK_W__header",
  "scollContent": "testimonialCarousel-module-scss-module__HcCK_W__scollContent",
});
